import React, { useState } from "react";
import { PageLayout } from "../components/page-layout";
import { Button, TextField, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { getGeminiChatResponse } from "../services/gemini-chat.service";

export const RulesPage = () => {
  const [question, setQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResponse("");

    try {
      const { response: apiResponse, error: apiError } = await getGeminiChatResponse(question);

      if (apiError) {
        throw new Error(apiError.message);
      }

      if (apiResponse.success) {
        setResponse(apiResponse.response);
      } else {
        setError(apiResponse.response || "An unknown error occurred.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Rules
        </Typography>
        <Typography variant="body1" paragraph>
          Ask a question about the rules:
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Your Question"
            id="ruleQuestion"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="e.g., How many transfers are allowed?"
            required
            variant="outlined"
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Submit Question"}
          </Button>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mt: 4 }}>
            Error: {error}
          </Alert>
        )}

        {response && (
          <Box sx={{ mt: 4, p: 3, border: '1px solid #ccc', borderRadius: '4px', bgcolor: 'background.paper' }}>
            <Typography variant="h6" component="h4" gutterBottom>
              Response:
            </Typography>
            <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
              {response}
            </Typography>
          </Box>
        )}
      </Box>
    </PageLayout>
  );
};